import { DEVELOPER_LOGO_HEIGHT } from 'components/project-page/project-details/developers';
import { TransformedImage } from 'components/transformed-image';
import React from 'react';
import { DeveloperLogo as DeveloperLogoWrapper } from 'components/project-page/developers-projects/styled';
import OfficePlaceholderIcon from 'assets/svg/office-placeholder.svg';
import OfficeSquarePlaceholderIcon from 'assets/svg/office-placeholder-square.svg';

interface DeveloperLogoProps {
  size: number;
  developerLogo?: string;
  isSquare?: boolean;
}

export const DeveloperLogo: React.FC<DeveloperLogoProps> = ({ developerLogo, size, isSquare }) => (
  <>
    {developerLogo ? (
      <DeveloperLogoWrapper data-auto="developer-image-container" size={size} noSideMargin>
        <TransformedImage path={developerLogo} height={DEVELOPER_LOGO_HEIGHT} />
      </DeveloperLogoWrapper>
    ) : (
    isSquare
      ? (
        <DeveloperLogoWrapper
          data-auto="developer-image-container"
          size={size}
          noSideMargin
          isSquare={isSquare}
          developerLogo={developerLogo}
        >
          <OfficeSquarePlaceholderIcon width={size - 5} height={size - 5} style={{ flexShrink: 0 }} />
        </DeveloperLogoWrapper>
      )
      : <OfficePlaceholderIcon width={size} height={size} style={{ flexShrink: 0 }} />
    )}
  </>
);
